var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncrease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.25C6.40625 0.25 0.25 6.40625 0.25 14C0.25 21.5938 6.40625 27.75 14 27.75C21.5938 27.75 27.75 21.5938 27.75 14C27.75 6.40625 21.5938 0.25 14 0.25ZM15.25 19C15.25 19.3315 15.1183 19.6495 14.8839 19.8839C14.6495 20.1183 14.3315 20.25 14 20.25C13.6685 20.25 13.3505 20.1183 13.1161 19.8839C12.8817 19.6495 12.75 19.3315 12.75 19V15.25H9C8.66848 15.25 8.35054 15.1183 8.11612 14.8839C7.8817 14.6495 7.75 14.3315 7.75 14C7.75 13.6685 7.8817 13.3505 8.11612 13.1161C8.35054 12.8817 8.66848 12.75 9 12.75H12.75V9C12.75 8.66848 12.8817 8.35054 13.1161 8.11612C13.3505 7.8817 13.6685 7.75 14 7.75C14.3315 7.75 14.6495 7.8817 14.8839 8.11612C15.1183 8.35054 15.25 8.66848 15.25 9V12.75H19C19.3315 12.75 19.6495 12.8817 19.8839 13.1161C20.1183 13.3505 20.25 13.6685 20.25 14C20.25 14.3315 20.1183 14.6495 19.8839 14.8839C19.6495 15.1183 19.3315 15.25 19 15.25H15.25V19Z",
    fill: "#414141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.c5099b0146770ff37507df46acd4cadb.svg";
export { ForwardRef as ReactComponent };